module.exports = __webpack_public_path__ + "img/hi.4a2e2dfd.svg";